export const WAREHOUSE_VI = {
  true: 'HOẠT ĐỘNG',
  false: 'KHÔNG HOẠT ĐỘNG',
  soldToAddress: 'Địa chỉ xuất hóa đơn',
  shipToAddress: 'Địa chỉ giao hàng',
  operationType: 'Hình thức vận hành',
  ownerInformation: 'Thông tin chủ sở hữu',
}
